import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from "ol/style/Fill.js";
import {getVectorContext} from "ol/render";
import {SWISSPARK_FILL_RESOLUTION} from "../constants";

const innerStrokeFill = new Style({
  stroke: new Stroke({
    color: "rgba(0, 159, 128, 0.5)",
    width: 40
  })
});

const borderStroke = new Stroke({
  color: 'rgba(0, 159, 128, 1)',
  width: 3
});

const filledPolygonStyle = [new Style({
  stroke: borderStroke,
  fill: new Fill({
    color: `rgba(0, 159, 128, 0.5)`
  })
})];

const onlyBorderStyle = [new Style({
  stroke: borderStroke
})];

export function setClippingGeometry(vectorContext, geometry) {
  const context = vectorContext.context_;
  const type = geometry.getType();
  const flatCoordinates = geometry.getOrientedFlatCoordinates();
  const stride = geometry.getStride();

  context.save();
  context.beginPath();
  if (type === "Polygon") {
    const ends = geometry.getEnds();
    for (let i = 0, ii = ends.length; i < ii; ++i) {
      vectorContext.moveToLineTo_(flatCoordinates, 0, ends[i], stride, true);
    }
  } else if (type === "MultiPolygon") {
    let offset = 0;
    const endss = geometry.getEndss();
    for (let i = 0, ii = endss.length; i < ii; ++i) {
      const ends = endss[i];
      offset = vectorContext.drawRings_(flatCoordinates, offset, ends, stride);
    }
  } else {
    console.error("Unsupported geometry type", type);
  }
  context.clip();
}

export function resetClipping(vectorContext) {
  vectorContext.context_.restore();
  // the save/restore mess with fill and stroke state.
  vectorContext.contextStrokeState_ = null;
  vectorContext.contextFillState_ = null;
}

export function createSwissparkStyle(is3d) {
  return (feature, resolution) => {
    if (is3d || resolution > SWISSPARK_FILL_RESOLUTION) {
      return filledPolygonStyle;
    }
    return onlyBorderStyle;
  };
}

export function updateInnerBuffer(event, layer) {
  const resolution = event.frameState.viewState.resolution;
  if (resolution > SWISSPARK_FILL_RESOLUTION) {
    return;
  }
  const vectorContext = getVectorContext(event);
  layer.getSource().forEachFeature((feature) => drawInnerBuffer(vectorContext, feature.getGeometry()));
}

export function drawInnerBuffer(vectorContext, geometry) {
  setClippingGeometry(vectorContext, geometry);
  vectorContext.setStyle(innerStrokeFill);
  vectorContext.drawGeometry(geometry);
  resetClipping(vectorContext);
}
